import React from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../../../Components/Utils/Breadcrumb";
import {
  BackButton,
  CreateButton,
  DownloadButton,
  EditButton,
} from "../../../../../Components/Utils/Buttons";
import { TwoNEWSmall2 } from "../../../../../Components/Utils/Select";
import { GetAccess, GetRole } from "../../../../../Components/Utils/roles";

const PrHeader = ({
  pageIndex,
  searchQuery,
  prOptions = [],
  selectedPrId,
  onPrSelectChange,
  handlePrevPR,
  handleNextPR,
  hasPrev,
  hasNext,
  setSearch,
  downloadPDF,
  prViewId,
  data,
  EditAccess = "purchase_request_edit",
}) => {
  const formikAdapter = {
    values: { prId: selectedPrId || "" },
    errors: {},
    handleChange: (e) => {
      onPrSelectChange(e.target.value);
    },
  };

  const renderActionButtons = () => (
    <>
      <Link
        to="/procurement/purchase-requests"
        state={{
          currentPage: pageIndex,
          searchQuery: searchQuery || "",
        }}
      >
        <BackButton link={true} />
      </Link>

      {(data?.status === "verified" || data?.status === "Verified") && (
        <Link
          to="/procurement/rfq/create"
          state={{ prId: data?.prId, ref: data?.ref }}
        >
          <CreateButton label="RFQ" />
        </Link>
      )}

      <DownloadButton handleClick={downloadPDF} label="Download PDF" />

      {data?.editable === false ? (
        GetRole() && (
          <Link
            to={`/procurement/purchase-requests/edit/${prViewId}`}
            state={{
              data: data,
              from: `/procurement/purchase-requests/view/${prViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>
        )
      ) : (
        GetAccess(EditAccess) && (
          <Link
            to={`/procurement/purchase-requests/edit/${prViewId}`}
            state={{
              data: data,
              from: `/procurement/purchase-requests/view/${prViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>
        )
      )}
    </>
  );

  return (
    <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
      {/* Left: Breadcrumb */}
      <div className="w-full md:w-auto flex justify-between items-center gap-2">
        <Breadcrumb
          items={[
            { name: "YPR", link: "/procurement/purchase-requests/" },
            { name: "View" },
          ]}
        />
        {/* Mobile Action Buttons */}
        <div className="flex md:hidden items-center gap-2 flex-wrap">
          {renderActionButtons()}
        </div>
      </div>

      {/* Right: PR Navigator + Desktop Action Buttons */}
      <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center justify-between md:justify-start gap-2">
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={handleNextPR}
            disabled={!hasNext}
            className="p-1 rounded-md border border-[#579BB1] text-[#579BB1] hover:bg-[#579BB1]/10 disabled:opacity-30 disabled:pointer-events-none transition-colors h-[27px] flex items-center justify-center w-[27px]"
            title="Previous YPR"
          >
            <svg
              className="w-4 h-4 stroke-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <TwoNEWSmall2
            placeholder="Choose YPR"
            Options={prOptions}
            formik={formikAdapter}
            name="prId"
            setSearch={setSearch}
            px={0}
            width="w-36 sm:w-40"
          />
          <button
            type="button"
            onClick={handlePrevPR}
            disabled={!hasPrev}
            className="p-1 rounded-md border border-[#579BB1] text-[#579BB1] hover:bg-[#579BB1]/10 disabled:opacity-30 disabled:pointer-events-none transition-colors h-[27px] flex items-center justify-center w-[27px]"
            title="Next YPR"
          >
            <svg
              className="w-4 h-4 stroke-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>

        {/* Desktop Action Buttons */}
        <div className="hidden md:flex items-center gap-2">
          {renderActionButtons()}
        </div>
      </div>
    </div>
  );
};

export default React.memo(PrHeader);
